import { jsx as _jsx } from "react/jsx-runtime";
const SvgDota2Tower = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.6493 0V1.74479H8.54857V0H6.45143V1.74479H4.35071V0H2.25V3.62761L3.87273 4.5V12H2.25V15H7.50895H12.75V12H11.175V4.5L12.75 3.62761V0H10.6493Z",
		fill: "currentColor"
	})
});
export default SvgDota2Tower;
